import React, { Component, PropTypes } from 'react';
import { formatNumber, DateFormatter } from '../../utils/date';
import Carousel from '../carousel/carousel';
import forEach from 'lodash/forEach';
import { casesRoute } from '../../routes/index';
import { Link } from 'react-router';
import formatCredits from '../../utils/formatCredits';
import SweetScroll from 'sweet-scroll';

import TimelineIntroElement from '../timeline/timelineIntroElement';

//import { Motion, spring } from 'react-motion';

import Image from '../image/image';
import getCategoryName from '../../utils/getCategoryName';

import Share from '../../components/share/share';

import css from './timelineHero.scss';

import Pixeltext from '../svg/pixeltext';
import { Player, PlayerTrigger } from '../video/player';

import img1 from './case-1.png';
import img2 from './case-2.png';
import img3 from './case-3.png';
import img4 from './case-4.png';

var DEBUG_ID = 0;

export default class TimelineHeroMonthElement extends Component {
	static propTypes = {
		points: PropTypes.number.isRequired,
		profiles: PropTypes.array.isRequired,
		createdDate: PropTypes.string.isRequired,
		description: PropTypes.string.isRequired,
		categories: PropTypes.array.isRequired,
		title: PropTypes.string.isRequired,
		slide1: PropTypes.object,
		slide2: PropTypes.object,
		slide3: PropTypes.object,
		browser: PropTypes.object.isRequired,
		awards: PropTypes.array.isRequired,
		awardId: PropTypes.number.isRequired,
		sortDate: PropTypes.string.isRequired,
		isFirstHero: PropTypes.bool.isRequired,
		showreelUrl: PropTypes.string.isRequired,
		before: PropTypes.string.isRequired,
	};
	static defaultProps = {
		points: 0,
		profiles: [],
		createdDate: '',
		categories: [],
		title: 'Unknown',
		slide1: '',
	};

	constructor(props) {
		super(props);

		this.mounted = true;
		this.boundingRect = false;

		//this.testbg = `rgb(${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1})`;
		this.state = {
			introElementOffset: 0,
			showVideo: false,
			showCredits: false,
		}

		this.componentFirstClass = '';

		if (this.props.isFirstHero) {
			this.componentFirstClass = ' first';
		}
	}

	componentDidMount() {
		this.DEBUG = DEBUG_ID++;
	}

	componentWillReceiveProps(nextProps) {

	}

	componentWillUnmount() {
		this.mounted = false;
	}

	shouldComponentUpdate(nProps, nState) {
		return (
			nState !== this.state ||
			nProps.browser.window.width !== this.props.browser.window.width ||
			nProps.createdDate !== this.props.createdDate ||
			nProps.title !== this.props.title ||
			nProps.className !== this.props.className || 
			nProps.browser.window.width !== this.props.browser.window.width
		);
	}

	componentDidUpdate() {
		//this.boundingRect = this.refs.timelineCase.getBoundingClientRect();
	}



	render() {
		//let { title, categories, profiles, points, createdDate } = this.props.item;
		let createdDate = new DateFormatter(this.props.sortDate);
		let winDate = new DateFormatter();
		let days = this.props.days;
		let awardTitle = '';
		let awardType = '';
		let _this = this;

		let url = casesRoute(this.props.slug);

		forEach(this.props.awards, function(award) {
			if (award.id == _this.props.awardId) {
				awardTitle = award.name;
				awardType = award.type;
				winDate = new DateFormatter(award.awardFor);
			}
		});

		awardType = awardType.toLowerCase();

		let ribbonClass = 'ribbon-' + awardType;
		ribbonClass += ' ribbon-' + awardType + '--tr';

		let imgSpan = { desktop: 'span9', tablet: 'span14', mobile: 'span12' };

		//Scorecard things

		/*<div className='span1 hide-tablet timeline-hero__glitter-scorecard'>
			<div className='timeline-hero__glitter-scorecard__score'>
				{formatNumber(this.props.points)} <small>Points</small>
			</div>
			<div className='timeline-hero__glitter-scorecard__days'>
				{days} <small>Days</small>
			</div>
			<div className='timeline-hero__details__profile'>{formatCredits(this.props.profiles)}</div>
		</div>*/

		let slides = [];
		for (let i = 1; i <= 3; i++) {
			(this.props['slide' + i]) && slides.push(
				<Link to={url} key={'slide' + i}>
					<Image img={this.props['slide' + i]} span={imgSpan} alt='' browser={this.props.browser} />
				</Link>
			);
		}

		(!!this.props.showreelUrl) && slides.push(
			<PlayerTrigger key='slideVideo' url={this.props.showreelUrl} codaClass='slide-coda__item--is-video' skipSlide onClick={(e) => {
				this.setState({
					...this.state,
					showVideo: !this.state.showVideo,
				});
			}} />
		);

		return (
			<li className='timeline__hero span14' ref='timelineElement'>

				<TimelineIntroElement before={this.props.before} browser={this.props.browser} title={this.props.title} timelineElement={this.getElement()} child={this.child} awardTitle={awardTitle} winDate={winDate} />

				<div className={'timeline-hero' + this.componentFirstClass} ref='timelineCase'>
					<div className='timeline-hero__details span5 span14-tablet'>
						<div className='timeline-hero__details-top'>
							<div className='timeline-hero__details-award month span2 span4-tablet pixel-pattern span14-mobile'>
								<span className='timeline-hero__details-award--type'>{awardTitle + ' —'}</span>
								<span className='timeline-hero__details-award--month month'>{winDate.month}</span>
							</div>
							<div className='timeline-hero__details-share'>
								<Share title={this.props.title} url={window.location.protocol + '//' + window.location.host + casesRoute(this.props.slug)} browser={this.props.browser} />
							</div>
						</div>
						<div className='timeline-hero__details-description'>
							<section className='timeline-hero__details-description__content span4'>
								<h3 className='timeline-hero__details__category'>{getCategoryName(this.props.caseTypes.name, this.props.bestViewedOn)}</h3>
								<h2 className='timeline-hero__details__title'>{this.props.title}</h2>
								<p className='timeline-hero__details__excerpt'>{this.props.description}</p>
							</section>
						</div>
					</div>
					<div className='span14-tablet timeline-hero__slider-holder span9 span12-mobile pixel-pattern pixel-pattern--dark pixel-pattern--01'>
						<Carousel autoplay={false}>
							{slides}
						</Carousel>
						<div className={ribbonClass}></div>

						{(!!this.props.showreelUrl) && (
							<Player url={this.props.showreelUrl} showVideo={this.state.showVideo} onClose={() => { this.setState({ ...this.state, showVideo: false }); }} browser={this.props.browser} />
						)}
					</div>
					<div className='span2 hide-desktop hide-tablet timeline-hero__slider-buttons'></div>
					<div className='timeline-hero__meta-scorecard span4 span8-tablet span12-mobile pixel-pattern hide-tablet hide-desktop'>
						{(!this.props.legacy) && (
							<div>
								<div className='timeline-hero__meta-scorecard__stats hide-mobile'>
									<h3 className='timeline-hero__meta-scorecard__title'>FWA award stats:</h3>
								</div>
								<div className='timeline-hero__meta-scorecard__points span2 span4-tablet span6-mobile'>
									<h3 className='timeline-hero__meta-scorecard__title'>Points:</h3>
									<span className='timeline-hero__meta-scorecard__number'>{formatNumber(this.props.points)}</span>
								</div>
								<div className='timeline-hero__meta-scorecard__days span2 span4-tablet span6-mobile'>
									<h3 className='timeline-hero__meta-scorecard__title'>Days:</h3>
									<span className='timeline-hero__meta-scorecard__number'>{days}</span>
								</div>
							</div>
						)}
					</div>
					<div className='timeline-hero__details-description--tablet span10 span14-mobile'>
						<section className='timeline-hero__details-description__content span8 span12-mobile'>
							<h3 className='timeline-hero__details__category'>{getCategoryName(this.props.caseTypes.name, this.props.bestViewedOn)}</h3>
							<h2 className='timeline-hero__details__title'>{this.props.title}</h2>
							<p className='timeline-hero__details__excerpt span8-tablet'>{this.props.description}</p>
						</section>
					</div>
					<section className='timeline-hero__meta-credit span5 span4-tablet hide-mobile'>
						<h3 className='timeline-hero__meta-credit__title'>Credits:</h3>
						<span className='timeline-hero__meta-credit__name'>{formatCredits(this.props.profiles)}</span>
					</section>

					<div className='timeline-hero__meta-scorecard span4 span8-tablet pixel-pattern hide-mobile'>
						{(!this.props.legacy) && (
							<div>
								<div className='timeline-hero__meta-scorecard__stats'>
									<h3 className='timeline-hero__meta-scorecard__title'>FWA award stats:</h3>
								</div>
								<div className='timeline-hero__meta-scorecard__points span2 span4-tablet'>
									<h3 className='timeline-hero__meta-scorecard__title'>Points:</h3>
									<span className='timeline-hero__meta-scorecard__number'>{formatNumber(this.props.points)}</span>
								</div>
								<div className='timeline-hero__meta-scorecard__days span2 span4-tablet'>
									<h3 className='timeline-hero__meta-scorecard__title'>Days:</h3>
									<span className='timeline-hero__meta-scorecard__number'>{days}</span>
								</div>
							</div>
						)}
					</div>
					<div className='timeline-hero__meta-more span5 span6-tablet span14-mobile'>
						<a className='timeline-hero__meta-more__button button--credit button hide-tablet hide-desktop' onClick={() => this.setState({ ...this.state, showCredits: !this.state.showCredits })}>{this.state.showCredits ? 'Credits -' : 'Credits +'}</a>
						{this.props.url && (
						<a href={this.props.url} target='_blank' className='timeline-hero__meta-more__button button--go button--dark button'>Launch Project</a>
						)}
						<Link to={url} className='timeline-hero__meta-more__button button'>
							See Case
						</Link>
					</div>
					<div className='timeline-hero__down span8 span10-mobile'>
						<div className='timeline-hero__down__left span6'></div>
						<a href='#' className='timeline-hero__down__right span2' onClick={(event) => this.scroll(event)}>
							<span className='timeline-hero__down__arrow'></span>
						</a>
					</div>
					<section className={'timeline-hero__meta-credit span14 hide-tablet hide-desktop' + (this.state.showCredits ? '' : ' timeline-hero__meta-credit--hide')}>
						<h3 className='timeline-hero__meta-credit__title'>Credits:</h3>
						<span className='timeline-hero__meta-credit__name'>{formatCredits(this.props.profiles)}</span>
					</section>
				</div>
			</li>
		);
	}

	scroll(e) {
		e.preventDefault();

		if (this.refs.timelineElement) {
			const scroller = new SweetScroll({ easing: 'easeOutQuint', offset: -60, duration: 700 });
			let scroll = this.refs.timelineElement.offsetHeight + this.refs.timelineElement.offsetTop;
			scroller.to(scroll);
		}
	}

	getElement() {
		return this.refs.timelineElement;
	}

	getIntroElement() {
		return this.refs.introElement;
	}

	getIntroElementFade() {
		return this.refs.introElementFade;
	}

	getIntroElementStopper() {
		return this.refs.introElementStopper;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/timelinehero/timelineHeroMonth.js
 **/